/**
 * DB-granted permission key for the super-user permission-management surface
 * (GF-4659). Single source of truth imported by the route guard, the AppLayout
 * nav gate, and the admin page's self-revoke guard. Mirrors
 * `pricing-action-permissions.ts`.
 */
export const USER_PERMISSIONS_MANAGE = 'user_permissions.manage';
